/**
 * BLOCK: post
 */
class LutherBlogSidebar {
  constructor() {
    this.navItems = [...document.querySelectorAll(".entry-sidebar > .toc li")];
    this.headings = [...document.querySelectorAll(".entry-content h2")];
    this.updateActiveClasses();
    this.scrollHandler = this.updateActiveClasses.bind(this); // nötig damit removeEventListener funktioniert
    window.addEventListener("scroll", this.scrollHandler);
  }

  destroy() {
    window.removeEventListener("scroll", this.scrollHandler);
  }

  updateActiveClasses() {
    const activeHeadingIndex = this.getActiveHeadingIndex();
    for (let i = 0; i < this.navItems.length; i++) {
      if (i === activeHeadingIndex) {
        this.navItems[i].classList.add("active");
      } else {
        this.navItems[i].classList.remove("active");
      }
    }
  }

  getActiveHeadingIndex() {
    let index = 0;

    for (let i = 0; i < this.headings.length; i++) {
      const current = this.getViewportXPosition(this.headings[i]);

      if (current.isInView || current.isAbove) {
        const prev = this.getViewportXPosition(this.headings[i - 1]);
        if (!prev.isInView) {
          index = i;
        }
      }
    }
    return index;
  }

  getViewportXPosition(element = false) {
    if (!element) return { isAbove: false, isInView: false };

    const bounding = element.getBoundingClientRect();
    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight;
    const isAbove = bounding.top < 0;
    const isBelow = bounding.bottom > windowHeight;
    const isInView = !isAbove && !isBelow;
    return { isAbove, isInView };
  }
}

window.addEventListener("DOMContentLoaded", () => {
  function updateLutherBlogSidebarInstances() {
    if (window.luther.blogSidebar) {
      window.luther.blogSidebar.destroy();
      delete window.luther.blogSidebar;
    }

    const sidebarTOC = document.querySelector(".entry-sidebar > .toc");
    if (sidebarTOC) {
      window.luther = window.luther || {};
      window.luther.blogSidebar = new LutherBlogSidebar(sidebarTOC);
    }
  }

  window.luther.eventBus.on(
    "luther:pageContentChange",
    updateLutherBlogSidebarInstances,
  );

  updateLutherBlogSidebarInstances();
});
